__turbopack_context__.v({
  "travelerButton": "MsEhSa_travelerButton",
  "travelerDetails": "MsEhSa_travelerDetails",
  "travelerInfo": "MsEhSa_travelerInfo",
  "travelerItem": "MsEhSa_travelerItem",
  "travelersContent": "MsEhSa_travelersContent",
});
